function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { white, black70, grey60, blue, grey6 } from './colors.js';
import customColors from './customColors.js';
import zIndex from './zIndex.js';

/**
 * Shared theme config for all of the workspaces. This allows us to maintain a
 * consistent visual experience across projects. For changes that only
 * need to modify a single app, override this base theme and pass the
 * modified version into your root themeProvider
 */

const size = {
  tiny: '2px',
  small: '4px',
  medium: '8px',
  large: '16px',
  huge: '24px',
  enormous: '32px'
};
const fontSize = {
  tiny: '12px',
  small: '14px',
  medium: '16px',
  large: '18px',
  huge: '24px',
  super: '32px',
  mega: '48px'
};
const breakpoints = {
  giant: 1170,
  desktop: 992,
  tablet: 768,
  phone: 560
};
const fontWeight = {
  ultraLight: 400,
  thin: 400,
  light: 400,
  regular: 400,
  medium: 400,
  demiBold: 500,
  bold: 600,
  heavy: 600
};
const fallbackFonts = `-apple-system,
BlinkMacSystemFont,
"Segoe UI",
"Roboto",
"Oxygen",
"Ubuntu",
"Cantarell",
"Fira Sans",
"Droid Sans",
"Helvetica Neue",
sans-serif`;
const monospaceFont = {
  fontFamily: `
  "Monaco",
  monospace;`
};
const fontFamily = {
  regular: `'CoinbaseSans', ${fallbackFonts}`,
  sans: `'CoinbaseSans', ${fallbackFonts}`,
  text: `'CoinbaseText', ${fallbackFonts}`,
  display: `'CoinbaseDisplay', ${fallbackFonts}`,
  monospace: monospaceFont.fontFamily
};
const color = {
  background: white,
  backgroundAlt: customColors.lightGrey,
  // Text
  text: black70,
  textLight: grey60,
  textAccent: blue,
  textHover: blue,
  textAccentHover: customColors.blue80,
  // Borders
  border: grey6,
  // Buttons
  buttonFill: blue,
  buttonFillHover: customColors.darkBlue,
  buttonText: white,
  secondaryButtonFill: white,
  secondaryButtonText: blue,
  white: white,
  blue: blue
};
const border = {
  border: `1px solid ${color.border}`,
  noRadius: '0px',
  subtleRadius: '2px',
  borderRadius: `${size.small}`,
  mediumBorderRadius: `${size.medium}`,
  largeBorderRadius: `${size.large}`,
  radius: `${size.small}`,
  insetRadius: '3px'
};
const layout = {
  extraWide: 1920,
  width: 1180,
  padding: 24
};
const theme = {
  typeVariant: false,
  // temporary variant, will be removed post design system launch
  size,
  fontSize,
  fontWeight,
  fontFamily,
  color: _objectSpread(_objectSpread({}, customColors), color),
  border,
  layout,
  breakpoints,
  zIndex,
  _snapshotDisplayName: 'defaultTheme',
  logoKey: 'blue'
};
export { theme };
//# sourceMappingURL=theme.js.map
